export interface ILoyaltyPointsHistory {
    id: number;
    customerId: number;
    firstname: string;
    lastname: string;
    email: string;
    itemFinalPrice: number;
    numberOfPoints: number;
    discountAmount: number;
    isExpired: boolean;
    expireDate: null | Date;
    chargeType: LoyaltyPointsHistoryChargeTypes;
    appointmentId: number | null;
    dropinReservationId: number | null;
    clientSubscriptionId: number | null;
    createdAt: Date;
    isFromReferral: boolean;
}

export enum LoyaltyPointsHistoryChargeTypes {
    Deduction,
    Receive
}

export interface ICustomerLoyaltyBalance {
    id: number,
    loyaltyPointsBalance: number,
    earliestExpireDate: Date | null,
    earliestExpirePoints: number | null
}

export interface ILoyaltyPointsExchangesForCustomer {
    id: number;
    numberOfPoints: number;
    userReceive: number;
}